<template>
	<span>
        <div class="row row-wrap">
            <a :id="branch.sid + 'Side'" class="col-xs-12 aItem row sideless ellipsis" style="margin: 0px; text-align: left;" @click.prevent="item_clicked(branch)">
                <div class="icon-text-container" style="white-space: nowrap; overflow: hidden;" 
                :class="{'active-tree-item fsable': (branch.sid == $root.active_tree_item.id && ($route.query.p == branch.idp || $route.query.p == null ) && ($route.params.focus == null) )}">
                    <span style="padding: 0px;">
                        <div class="sideless side-branch"
                        v-if="!isFirstSon" :class="{'last': isLastSon}">
                            <div class="branch top"></div>
                            <div class="branch bot"></div>
                        </div>
                        <i :class="$root.prod_icons[branch.typ] ? $root.prod_icons[branch.typ].icn : $root.icons.dir"></i> 
                    </span>

                    <span v-if="branch.children" @click.stop="arrow_clicked()" style="padding: 5px;">
                        <i class="fa" :class="[children.length == 0 && uses.length == 0 ? $root.icons.right : $root.icons.down ]"></i>
                    </span>
                    
                    <!--DEFAULT: codice - descrizione-->
                    <div class="hide-collapse" style="visibility: initial;" :style="branch.ist || children.length == 0 ? {'font-weight': 650} : ''">
                        <popover-alert v-if="$Components['supportSidebar.impieghi'].showRedQty" effect="fade" placement="right" trigger="hover" 
                            :content="$Jed.firstUpperTranslate('total quantity')" 
                            :popoverCondition="info_qty"
                            :popoverStyle="{'max-width': '120px', 'width': '120px', 'font-size': 'small', 
                                          'height': '40px', 'position':'absolute'}" 
                            :showOK="false" :showNO="false" :textStyle="{color: '#222'}">

                            <span v-if="branch.qty" id="popoup_in_right_sidebar"
                                :style="$Components['supportSidebar.impieghi'].showRedQty ? 
                                    {'margin-left': '5px','margin-right': '5px','padding':'5px','color': 'red', 'font-weight': 650} : ''"
                                @mouseover="mouse_over">
                                {{$Components['supportSidebar.impieghi'].showRedQty ? branch.qty : ' - '+branch.qty}}
                            </span>

                        </popover-alert>

                        <span v-if="$Components['supportSidebar.impieghi'].showId && $Components['supportSidebar.impieghi'].showDes">{{branch.sid +' - '+ branch.des}}</span>
                        <span v-else-if="$Components['supportSidebar.impieghi'].showId">{{branch.sid}}</span>
                        <span v-else-if="$Components['supportSidebar.impieghi'].showDes">{{branch.des}}</span>
                        <span v-if="branch.qty && !$Components['supportSidebar.impieghi'].showRedQty">{{' - '+branch.qty}}</span>
                        <span v-if="branch.pos">{{' - '+branch.pos}}</span>
                    </div>
                </div>
            </a>
        </div>

        <ul class="sidebar-menu" :class="{'first': isFirstSon, 'child': !isFirstSon, 'fatherlast': isLastSon}" >
            <li class="pageLink" v-for="(child, index) in children">

            <use-item :key="index" :branch="child" :isFirstSon="false" :isLastSon="index == children.length -1 && (uses == null || uses.length == 0)">
            </use-item>

            </li>

            <li class="pageLink" v-for="(child, index) in uses">
                <div class="row row-wrap">
                    <a :id="child.sid + 'Side'" class="col-xs-12 aItem row sideless ellipsis" style="margin: 0px; text-align: left;" @click.prevent="item_clicked(child)">

                        <div class="icon-text-container" 
                        :class="{
                        'active-tree-item fsable': (child.sid == $root.active_tree_item.id && ($route.query.p == child.idp || $route.query.p == null ) && ($route.params.focus == null || !isChild)), 
                        'active-tree-use fsable' : (branch.sid == $root.active_tree_item.id && ($route.query.p == branch.idp || $route.query.p == null ) && ($route.params.focus == child.pos))
                        }">
                            <span style="padding: 0px;">
                            <!-- width: 5%; -->
                            <div class="sideless side-branch"
                            v-if="!isFirstSon" :class="{'last': index == uses.length -1}">
                                <div class="branch top"></div>
                                <div class="branch bot"></div>
                            </div>
                            <i :class="[child.cco != null && child.cco > 0 ? $root.icons.dir : $root.icons.leaf]"></i>
                            </span>
                            
                            <div class="hide-collapse" style="visibility: initial;">{{child.des}}<span v-if="child.pos">{{' - '+child.pos}}</span><span v-if="child.qty">{{' - '+child.qty}}</span></div>
                        </div>
                    </a>
                </div>
            </li>
        </ul>

      
	</span>
</template>

<script>

import PopoverAlert from "./../dynamic/popoverWrapper/Popover.vue";

    export default {
        name: "use-item",
        props: ["branch", "isFirstSon", "isLastSon", "isChild"],
        data: function(){
            return {
                children: [],
                uses: [],
                info_qty: false
            }
        }, 
        components: {
            PopoverAlert
        },
        mounted: function(){
            this.arrow_clicked();
            //console.log(this.branch.typ)
        },
        methods: {
            arrow_clicked: function(){
                if(this.children.length == 0 && this.uses.length == 0){
                    for(var prop in this.branch.children){
                        if(prop != "uses"){
                            this.children.push(this.branch.children[prop]);
                        } else if(!this.$root.preferences.hideUses){ //la visualizzazione delle foglie è regolata dalla preferenza
                            this.uses = this.branch.children[prop];
                        }
                    }
                    if(this.$Behaviors.usesDescending){
                        this.children.sort((a,b)=>{return ((a.sid < b.sid) ? 1 : ((a.sid > b.sid) ? -1 : 0))}); //ordinamento decrescente
                    }else{
                        this.children.sort((a,b)=>{return ((a.sid > b.sid) ? 1 : ((a.sid < b.sid) ? -1 : 0))}); //ordinamento crescente
                    }
                } else {
                    this.children = [];
                    this.uses = [];
                }
            },
            item_clicked: function(target){
                var vm = this;
                var clm = localStorage.getItem("current_loaded_model")
                if(clm!='null' && clm!=null && !target.idp.includes(clm)){ //se c'è un modello caricato nell'albero e l'elemento cliccato appartiene a un altro ramo, non navigo
                    this.$root.simpleNotification("info", {
                        title: "", 
                        message: this.$Jed.firstUpperTranslate("you can browse only the nodes of the machine loaded in the tree"),
                        displayMode: 'once' 
                    });
                    return;
                }

                if(target.pos == null || (target.cco != null && target.cco > 0)){
                    var sidPos;
                    this.$root
                        .microservice({
                        role: "catalog",
                        cmd: "SearchByFather",
                        params: {
                            //id padre
                            fid: target.sid,
                            //labels all richiede che il servizio ritorni (tradotte) tutte le informazioni gestite
                            labels: "all",
                            //laves false indica che non voglio reperire nodi che non hanno figli (parti, con cco == 0)
                            leaves: true,
                            //meta = true restituisce informazioni relative al percorso nel catalogo
                            meta: false
                        }
                        })
                        .then(
                            response => {
                                if(response){
                                    try {
                                        var res = response.body;
                                        if(res.leaves && res.leaves.length>0){
                                            for(var i=0; i<res.leaves.length; i++){
                                                if(res.leaves[i].sid == vm.$root.richiestaImpiegoPerm.cod){
                                                    sidPos = res.leaves[i].pos
                                                    break
                                                }
                                            }
                                        }
                                        if(res.children && res.children.length>0 && !sidPos){
                                            for(var i=0; i<res.children.length; i++){
                                                if(res.children[i].sid == vm.$root.richiestaImpiegoPerm.cod){
                                                    sidPos = res.children[i].pos
                                                    break
                                                }
                                            }
                                        }
                                        if(sidPos!=null) this.$root.navigateTo(target.sid, null, sidPos, target.idp)
                                    } catch (err) {}
                                }
                        })
                } else {
                    this.$root.navigateTo(this.branch.sid, null, target.pos, this.branch.idp)
                }
            },
            mouse_over: function(){
                if(this.$Components['supportSidebar.impieghi'].showRedQty){
                    this.info_qty = true;
                    console.log('mouse_over')
                    $('#popoup_in_right_sidebar').mouseout(function(event){ //l'hover sull'area che comprende il popup non ne innesca la chiusura
                        event.stopPropagation();
                        console.log('popoup_in_right_sidebar hover event')
                    });
                }
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/components/menu-sup-components/use-list-item.vue?113cbd93